import * as React from 'react';
import { SVGProps } from 'react';

const IconColumnsSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 14h4V2H6v12zm-5 0h4V2H1v12zM11 2v12h4V2h-4z" />
  </svg>
);
export default IconColumnsSizeS;
